import axios from '@/utils/axios';
import { Survey } from '@/models/survey';
import { GenerationLimit } from '@/models/generation-limit';
import { Translations } from '@/models/translations';
import { plainToClass } from 'class-transformer';
import { SurveyPayloadElement } from '@/models/survey-payload-element';
import { SurveyOriginAnalyticsPayload } from '@/models/survey-origin-analytics-payload';
import { ANALYTICS_ACTIONS } from '@/models/enums/analytics-actions.enum';

type SurveyAnalyticsPayload = {
  survey: string;
  medium: number;
  action: ANALYTICS_ACTIONS;
};

type originDataPayload = {
  originLink: string;
  originGmbAddress?: string;
};

export class SurveysService {
  static getSurveys(
    payload: {
      [key: string]: number | string;
    } & SurveyOriginAnalyticsPayload
  ): Promise<Survey> {
    return axios.post('surveys/', payload).then(({ data }) => {
      return plainToClass(Survey, data);
    });
  }

  static getSurveysSession(id: string): Promise<Survey> {
    return axios
      .get(`surveys/${id}/`)
      .then(({ data }) => plainToClass(Survey, data));
  }

  static sendAnswer(payload: SurveyPayloadElement[]): Promise<Survey> {
    return axios.post('answers/', payload);
  }

  static getNextStep(id: string): Promise<Survey> {
    return axios
      .post(`surveys/${id}/next/`)
      .then(({ data }) => plainToClass(Survey, data));
  }

  static getChatGenerationsLimit(id: string): Promise<GenerationLimit> {
    return axios
      .get(`surveys/${id}/generation-limits/`)
      .then(({ data }) => plainToClass(GenerationLimit, data));
  }

  static getTranslations(lang: string): Promise<Translations> {
    return axios
      .get(`translations/${lang}/`)
      .then(({ data }) => plainToClass(Translations, data));
  }

  static sendSurveyAnalytics(
    payload: SurveyAnalyticsPayload
  ): Promise<SurveyAnalyticsPayload> {
    return axios.post(`surveys/analytics/`, payload);
  }

  static sendOriginAnalytics(
    id: string,
    originData: originDataPayload
  ): Promise<SurveyOriginAnalyticsPayload> {
    const payload = plainToClass(SurveyOriginAnalyticsPayload, originData);
    return axios.post(`surveys/${id}/origins/`, payload);
  }
}
